<div class="detail-content__files" *ngIf="files.length >= 1">
  <h3 class="font-weight-bold bold">{{ 'CARD_DETAIL.FILES' | translate }}</h3>
  <div class="detail-content__files-container">
    <ng-container *ngFor="let file of files">
      <a [href]="file.url" target="_blank" class="detail-content__file-item d-flex align-items-center">
        <img _ngcontent-c6="" class="pointer" height="36" src="assets/img/document-big.svg" width="36" alt="file">
        <span class="ml-2 file">{{ removeExtFromUrlFile(file.url) }}</span>
        <img class="pointer ml-auto" width="24" height="24" [alt]="'CARD_DETAIL.DOWNLOAD' | translate" src="assets/img/download.svg">
      </a>
    </ng-container>
  </div>
</div>